import { Dispatch } from "redux";
import { internalActionKeys } from "./internalActionKeys";
import { handleActionError } from "src/common/actions/actionErrorHandler";
import { AppContext } from "../types/appContext";
import { ReduxAction } from "../types/reduxAction";

export default class AppContextActions {
  static updateAppContext = (context: AppContext, dispatchError: boolean = true) => {
    return async (dispatch: Dispatch): Promise<boolean> => {
      try {
        const payload: ReduxAction<AppContext> = {
          type: internalActionKeys.SAVE_APP_CONTEXT,
          payload: context
        };
        dispatch(payload);
        return true;
      } catch (error) {
        handleActionError(error, dispatch, dispatchError);
        return false;
      }
    };
  };
}
